module.exports = __webpack_public_path__ + "static/img/1.f4056e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/link-us/1.jpg
// module id = NWYw
// module chunks = 1